import React, { FC, memo } from 'react'

import { GetServerSideProps } from '../redux/types'
import { ResponseLocals, PageProps } from '../common/types'
import { getMessagesFromLanguage } from '../i18n/utils'
import { getRoutesFromDomain } from '../routes/utils'
import ObjectOverview from '../components/object-overview'
import ObjectOverviewPageTransport, {
    ObjectOverviewParamsTransport,
} from '../transports/object-overview-page-transport'
import { deleteSession } from '../utils/delete-session'
import Page from '../components/common/page'
import { pageClient } from '../clients'
import { BaseTransport } from '../transports'

type Props = {
    objectOverviewLink: string
    sitePathname: string
    data: BaseTransport<ObjectOverviewPageTransport>
} & PageProps

const ObjectOverviewPage: FC<Props> = ({ objectOverviewLink, sitePathname, data }) => {
    const { data: objectOverviewPageTransport } = data

    if (!objectOverviewPageTransport) {
        return null
    }

    const { head, staticData, objectsSection } = objectOverviewPageTransport
    const { navigationSection, newsLetterSection, footerSection } = staticData

    return (
        <Page head={head}>
            <ObjectOverview
                objectOverviewLink={objectOverviewLink}
                sitePathname={sitePathname}
                navigationSection={navigationSection}
                newsLetterSection={newsLetterSection}
                footerSection={footerSection}
                footerLogo={navigationSection.navigation.logo}
                socialMediaLinks={navigationSection.socialMediaLinks}
                objects={objectsSection?.objects || []}
                ownerName={objectsSection?.ownerName ?? null}
                totalCount={objectsSection?.totalCount}
                currentPage={objectsSection?.currentPage}
                totalPages={objectsSection?.totalPages}
            />
        </Page>
    )
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ req, res, query }) => {
    const { user, device } = res.locals as ResponseLocals

    const { objectOverviewLink, page: pageFromParams } = req.params as unknown as ObjectOverviewParamsTransport

    const pageFromQuery = query?.page as string | undefined
    const page = pageFromParams || pageFromQuery

    const linkParam = objectOverviewLink

    const sitePathname = req.path

    const baseObjectOverviewPageTransport = await pageClient.getObjectOverviewPage({
        user,
        params: { objectOverviewLink: linkParam, page, requestPath: sitePathname },
    })

    if (!baseObjectOverviewPageTransport.data || baseObjectOverviewPageTransport.status === 404) {
        return { notFound: true }
    }

    const requestUserConfig = deleteSession(user)

    const props: any = {
        objectOverviewLink: linkParam,
        sitePathname,
        data: baseObjectOverviewPageTransport,
        device,
        requestUserConfig: requestUserConfig,
        messages: await getMessagesFromLanguage(user.language),
        routes: await getRoutesFromDomain(user.domain),
    }

    if (page) {
        props.page = page
    }

    return { props }
}

export default memo(ObjectOverviewPage)
